import { Page } from "@betomorrow/micro-stores"
import { BoxLeadApiGateway } from "@modules/boxLead/gateway/boxLeadApiGateway"
import { BoxLeadDto, BoxLeadDtoSchema } from "@modules/boxLead/gateway/boxLeadDto"
import { BoxLeadInputDto } from "@modules/boxLead/gateway/boxLeadInputDto"
import { ApiClient } from "@modules/core/api/client/apiClient"
import { PaginatedWrapper, wrapperToPage } from "@modules/utils/paginated"

export class BoxLeadApi implements BoxLeadApiGateway {
  private baseUrl = "/box/members/leads"

  constructor(private api: ApiClient) {}

  async getBoxLeads(page = 0, size = 20, name?: string): Promise<Page<BoxLeadDto>> {
    const result = await this.api.get<PaginatedWrapper<BoxLeadDto>>(`${this.baseUrl}`, {
      params: { page, size, name },
    })
    const pageResult = wrapperToPage(result.data)
    return {
      ...pageResult,
      content: pageResult.content.map((lead) => BoxLeadDtoSchema.parse(lead)),
    }
  }

  async getBoxLead(leadId: string): Promise<BoxLeadDto> {
    const result = await this.api.get<BoxLeadDto>(`${this.baseUrl}/${leadId}`)
    return BoxLeadDtoSchema.parse(result.data)
  }

  async createBoxLead(leadInput: BoxLeadInputDto): Promise<void> {
    await this.api.post(`${this.baseUrl}`, leadInput)
  }

  async updateBoxLead(leadId: string, leadInput: BoxLeadInputDto): Promise<void> {
    await this.api.put(`${this.baseUrl}/${leadId}`, leadInput)
  }

  async deleteBoxLead(leadId: string): Promise<void> {
    await this.api.delete(`${this.baseUrl}/${leadId}`)
  }
}
